import jwtDecode from 'jwt-decode';
import { auth } from '../config';

export const accessTokenObj = () => {
    if (!auth.isNotDefined && auth.getOkta().getAccessToken()) {
        return jwtDecode(auth.getOkta().getAccessToken());
    }
};
